import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import apThemeReducer from 'common/store/ap-theme';
import authenticationReducer from 'common/store/authentication';
import cashoutReducer from 'common/store/cashout';
import depositReducer from 'common/store/deposit';
import globalReducer from 'common/store/global';
import microMerchantReducer from 'common/store/micro-merchant';
import paymentLinkReducer from 'common/store/payment-link';
import sessionReducer from 'common/store/session';
import walletTransferReducer from 'common/store/wallet-transfer';

const globalPersistConfig = {
  key: '__ONE_TOUCH__GLOBAL__',
  vesrion: 0,
  storage: storage,
  blacklist: [],
};

const sessionPersistConfig = {
  key: '__ONE_TOUCH__SESSION__',
  vesrion: 0,
  storage: storage,
  blacklist: [],
};

const cashoutPersistConfig = {
  key: '__ONE_TOUCH__CASHOUT__',
  vesrion: 0,
  storage: storage,
  blacklist: [],
};

const depositPersistConfig = {
  key: '__ONE_TOUCH__DEPOSIT__',
  vesrion: 0,
  storage: storage,
  blacklist: [],
};

const paymentLinkPersistConfig = {
  key: '__ONE_TOUCH__PMLINK__',
  vesrion: 0,
  storage: storage,
  blacklist: [],
};

const walletTransferPersistConfig = {
  key: '__ONE_TOUCH__WALLET_TRANSFER__',
  vesrion: 0,
  storage: storage,
  blacklist: [],
};
const authenticationPesistConfig = {
  key: '__ONE_TOUCH__AUTHENTICATION__',
  vesrion: 0,
  storage: storage,
  blacklist: [],
};

const apTheme = {
  key: '__APTHEME__',
  vesrion: 0,
  storage: storage,
  blacklist: [],
};
const store = configureStore({
  reducer: {
    global: persistReducer(globalPersistConfig, globalReducer),
    session: persistReducer(sessionPersistConfig, sessionReducer),
    cashout: persistReducer(cashoutPersistConfig, cashoutReducer),
    deposit: persistReducer(depositPersistConfig, depositReducer),
    walletTransfer: persistReducer(walletTransferPersistConfig, walletTransferReducer),
    paymentLink: persistReducer(paymentLinkPersistConfig, paymentLinkReducer),
    microMerchant: persistReducer(paymentLinkPersistConfig, microMerchantReducer),
    apTheme: persistReducer(apTheme, apThemeReducer),
    authentication: persistReducer(authenticationPesistConfig, authenticationReducer),
  },
  middleware: getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);

// export store singleton instance
export default store;
